document.addEventListener("turbolinks:load", e => {

  $(".single-select").on('change', function() {
    $('input[name="' + this.name + '"]').not(this).prop('checked', false);
  });

  $("[id$='violation_start']").timepicker({
                                              timeFormat: 'h:mm p',
                                              interval: 60,
                                              dynamic: false,
                                              dropdown: true,
                                              scrollbar: true
                                          });

  $("[id$='violation_end']").timepicker({
                                            timeFormat: 'h:mm p',
                                            interval: 60,
                                            dynamic: false,
                                            dropdown: true,
                                            scrollbar: true
                                        });

});